<div [class]="hoverColor" [title]="title">
    <img
      [class]="cursor"
      src="./assets/icons/download.svg"
      alt="export"
      [width]=width
      [height]=height
      (click)="fnDownloadExcel()"
    />
</div>
